import api from 'Application/api/api';

const requestTemplateQuestionFilesDownload = (
    templateId,
    questionId,
    isCustomQuestion,
    cancelToken = null,
) =>
    api.post(
        `project-manager/templates/${templateId}/questionnaire/questions/${questionId}/${
            isCustomQuestion ? 1 : 0
        }/files/download-requests`,
        {
            cancelToken,
        },
    );

export default requestTemplateQuestionFilesDownload;
